import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          i uploud succes

        </p>
      
      </header>
    </div>
  );
}

export default App;
